import React from "react";
import { Box, Divider, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "@jumbo/components/GridContainer";
import "@ckeditor/ckeditor5-build-classic/build/translations/fa";
import { useSelector } from "react-redux";
import LimitSettings from "./LimitSettings";
import GeneralSettings from "./GeneralSettings";
import ConfirmMessage from "./ConfirmMessage";
import ExamSettings from "./ExamSettings";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "1rem",
  },
  divider: {
    marginBlock: "16px",
  },
  textFieldLabel: {
    color: theme.palette.primary.main,
    marginBottom: "16px",
    fontWeight: "bold",
  },
  formControl: {
    width: "100%",
  },
}));

const FormSettingFields = () => {
  const classes = useStyles();

  const { currSettings } = useSelector(({ formBuilder }) => formBuilder);

  const getCurrSettings = () => {
    switch (currSettings) {
      case "GENERAL":
        return <GeneralSettings />;
      case "LIMIT":
        return <LimitSettings />;
      case "CONFIRM_MESSAGE":
        return <ConfirmMessage />;
      case "EXAM_SETTINGS":
        return <ExamSettings />;
      default:
        return null;
    }
  }

  return (
    <Box className={classes.root}>
      <Typography variant="h2" color="textSecondary">
        تنظیمات
      </Typography>
      <Divider className={classes.divider} />
      <GridContainer>
        {getCurrSettings()}
      </GridContainer>
    </Box>
  );
};

export default FormSettingFields;
